module.exports = __webpack_public_path__ + "img/case-logo-13.b3354074.png";